import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import CraReadiness from "@/pages/CraReadiness";
import Iec62443 from "@/pages/Iec62443";
import MachineryUkca from "@/pages/MachineryUkca";
import { Terms, Privacy, RefundPolicy } from "@/pages/LegalPages";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordPages";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import NewProduct from "@/pages/NewProduct";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Report from "@/pages/Report";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/cra-readiness" element={<CraReadiness />} />
      <Route path="/iec-62443" element={<Iec62443 />} />
      <Route path="/machinery-ukca" element={<MachineryUkca />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/products/new" element={<ProtectedRoute><NewProduct /></ProtectedRoute>} />
      <Route path="/assessment/:assessmentId" element={<ProtectedRoute><Assessment /></ProtectedRoute>} />
      <Route path="/results/:assessmentId" element={<ProtectedRoute><Results /></ProtectedRoute>} />
      <Route path="/report/:assessmentId" element={<ProtectedRoute><Report /></ProtectedRoute>} />
      <Route path="/admin/report/:assessmentId" element={<ProtectedRoute adminOnly><Report admin /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
